<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let fill = "white";
	//Constants
	//Variables
	//Functions
	//Do
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 14 14"
	fill="none"
>
	<path
		d="M14 1.16495C13.986 0.509765 13.4457 -0.0110224 12.7907 0.000177304L1.22399 0.0113794C0.568958 0.000179696 0.0286928 0.520968 0.0146963 1.17615V9.41355C-0.00489878 9.47234 -0.00489878 9.53114 0.0146963 9.58993V12.8351C0.0286928 13.4902 0.568958 14.011 1.22399 13.9998L12.7907 13.9886C13.4429 13.9998 13.9832 13.479 13.9972 12.8239V11.8579C13.9972 11.8579 13.9972 11.8551 13.9972 11.8523V1.16495H14ZM1.22399 0.579765L12.7907 0.568563C13.1266 0.562963 13.4037 0.83176 13.4121 1.16775V6.67801L11.3127 4.84966C11.2091 4.76006 11.0551 4.75726 10.9516 4.84406L6.25714 8.64076L3.85254 6.54641C3.74896 6.45682 3.595 6.45402 3.49143 6.54082L0.602549 8.87876V1.17895C0.610947 0.842962 0.888078 0.574165 1.22399 0.579765ZM13.4121 12.8267C13.4065 13.1627 13.1266 13.4314 12.7907 13.4258L1.22399 13.437C0.888078 13.4426 0.610947 13.1766 0.602549 12.8379V9.60394L3.66218 7.1288L6.06678 9.22314C6.17036 9.31274 6.32152 9.31555 6.42789 9.22875L11.1223 5.43205L13.4121 7.42559V11.6619C13.4121 11.6619 13.4121 11.6647 13.4121 11.6675V12.8267Z"
		style={`fill:${fill}`}
	/>
	<path
		d="M4.0009 4.63126C4.68953 4.63126 5.24939 4.07128 5.24939 3.3825C5.24939 2.69372 4.69233 2.13373 4.0009 2.13373C3.30947 2.13373 2.75241 2.69372 2.75241 3.3825C2.75241 4.07128 3.30947 4.63126 4.0009 4.63126Z"
		style={`fill:${fill}`}
	/>
</svg>

<style lang="scss">
</style>
